import { Box } from 'components/Box/Box';
import { Icon } from 'components/Icon';
import {
  AMP_PAGE_HEADER_NAV,
  AMP_PAGE_HEADER_NAV_MAP,
} from 'components/PageHeader/Amp/AmpPageHeaderConstants';

import { AmpPageHeaderNavLink } from './AmpPageHeaderNavLink';

type Props = {
  index: number;
  linkTo: string | { pathname: string; state: { redirectToContent?: boolean } };
  type: keyof typeof AMP_PAGE_HEADER_NAV_MAP;
  fullSize?: boolean;
  external?: boolean;
};

export function AmpPageHeaderTopNavLink({
  index,
  linkTo,
  type,
  fullSize,
  external,
}: Props) {
  const additionalProps = external ? { target: '_blank' } : {};

  return (
    <Box
      position="relative"
      height={[null, null, null, '100%']}
      display={['inline-block', null, null, 'flex']}
      alignItems="center"
    >
      <AmpPageHeaderNavLink
        data-qa-id={`nav-${type.toLowerCase().replace(/_/g, '-')}-link`}
        to={linkTo}
        $fullSize={fullSize}
        type={type}
        mr={index < AMP_PAGE_HEADER_NAV.length - 1 ? '1.5em' : undefined}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...additionalProps}
      >
        <Box classes={['flex', 'align-center']}>
          {AMP_PAGE_HEADER_NAV_MAP[type]}
          {external && (
            <Box transform="translateZ(0)" ml="4px" display="inline-flex">
              <Icon name="arrow-up-right" size={9} />
            </Box>
          )}
        </Box>
      </AmpPageHeaderNavLink>
    </Box>
  );
}
